
import {PollSample} from "../../helper/poll-sample";
import {LoadTdaData} from "../../tda/actions";


const poll_tda_item = (
  token, onboarding_items, username, identity_id, index, wlf_id, confirmed) => {
  const user_list = [ { username, wlf_id, identity_id, index, confirmed } ];

  // tda_account_number already exists, exit early.
  return new Promise((resolve, reject) => {
    if (onboarding_items.tda && onboarding_items.tda.tda_account_number) {
      return resolve(onboarding_items);
    }

    const poll_callback = new PollSample(
      1000,
      () => {
        return new Promise(resolve => {
          LoadTdaData(token, null, index, user_list)
            .then(result => {
              const tda_item = result.items.length === 1 && result.items[0];
              if (!tda_item || !('tda_account_number' in tda_item)) {
                return resolve(false);
              }
              onboarding_items.tda = tda_item;
              return resolve(true);
            })
        })
      },
      () => {
        console.log("tda_account_number not set");
        return reject();
      },
      30 * 1000,
      () => {
        return resolve(onboarding_items);
      }
    );

    poll_callback.startCallback();
  });
}

export { poll_tda_item };
